import { useAuth } from "@allergy123/auth-client/react";
import { Button, Container, DraftBanner, SiteFooter, SiteHeader } from "@allergy123/ui";
import type { ReactNode } from "react";
import { NavLink } from "react-router";

export const learnUrl = (import.meta.env.VITE_LEARN_URL as string | undefined) ?? "https://learn.allergy123.com";

export function RepsShell({ children }: { children: ReactNode }) {
  const { session, signOut } = useAuth();
  const link = (to: string, label: string) => (
    <NavLink to={to} end={to === "/"} className={({ isActive }) => (isActive ? "font-semibold text-anchor" : undefined)}>
      {label}
    </NavLink>
  );
  return (
    <div className="min-h-screen bg-canvas">
      {import.meta.env.MODE !== "production" && <DraftBanner>Development build — synthetic representative sign-in against the local API unless AUTH_* is set.</DraftBanner>}
      <SiteHeader
        logoVariant="auto"
        nav={
          <>
            {link("/", "My practices")}
            {link("/volume", "Volume")}
            {link("/statements", "Statements")}
            <a href={learnUrl}>Training</a>
          </>
        }
        actions={
          <>
            <span className="text-small text-ink-secondary">{session?.claims.email}</span>
            <Button variant="secondary" onClick={() => void signOut()}>
              Sign out
            </Button>
          </>
        }
      />
      <main>
        <Container className="py-12">{children}</Container>
      </main>
      <SiteFooter />
    </div>
  );
}
